import { useEffect, useState } from "react";
import "./AlertPopup.css";
import { isColorDark } from "./utility";
import { Button } from "@mui/material";

type AlertPopupProps = {
  message: string;
  color: string;
  cheatable: boolean;
  clearAlert: () => void;
  confirmTurn: () => void;
};

export function AlertPopup({ message, color, cheatable, clearAlert, confirmTurn }: AlertPopupProps) {
  const [cursorWithin, setCursorWithin] = useState<boolean>(false);
  useEffect(() => {
    let clearAlertTimeout: ReturnType<typeof setTimeout>;
    if (message !== "" && !cursorWithin) {
      clearAlertTimeout = setTimeout(() => {
        clearAlert();
      }, 3000);
    }
    return () => clearTimeout(clearAlertTimeout);
  }, [message, cursorWithin]);

  const isBackgroundDark = isColorDark(color);
  const canBeCheated = cheatable;
  return (
    <div
      className={"alert-popup" + (cursorWithin ? " animation-paused" : "")}
      style={{ backgroundColor: color, color: isBackgroundDark ? "white" : "black" }}
      onMouseEnter={() => {
        const element = document.querySelector(".alert-popup") as HTMLElement;
        const opacity = parseFloat(getComputedStyle(element).opacity);
        if (opacity === 1) {
          setCursorWithin(true);
        }
      }}
      onMouseLeave={() => setCursorWithin(false)}
    >
      {message}
      {canBeCheated && (
        <>
          <br></br>
          <span className="cheat-reminder">
            {" "}
            (are you sure this turn is legal?
            <Button onClick={confirmTurn} variant="contained">
              Do it anyway!
            </Button>
            )
          </span>
        </>
      )}
    </div>
  );
}
